import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteTagMutation } from "modules/TagsDashboard/components/DeleteTagModal/hooks";

import type { Tag } from "models";

type DeleteTagModalProps = {
  tag: Tag | null;
  onClose: () => void;
};

export const DeleteTagModal = ({ tag, onClose }: DeleteTagModalProps) => {
  const { t } = useTranslation();

  const { mutate: deleteTag, isPending } = useDeleteTagMutation();

  const handleDeleteTag = () => {
    if (tag === null) return;

    deleteTag({ id: tag.id }, { onSuccess: () => onClose() });
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={tag !== null}
      handleCancel={onClose}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
      handleConfirm={handleDeleteTag}
      isLoading={isPending}
    />
  );
};
